<template>
  <b-card :class="{ group: true, 'inactive-group-header': group.inactive }">
    <header class="title" @click="$emit('groupEntryClick', group)">
      <span>
        {{ group.name }}
        <GroupsInactive v-if="group.inactive" />
      </span>
      <b-button
        class="mdi mdi-chevron-right btn go-to-group"
        variant="outline-primary"
      >
      </b-button>
    </header>
    <section class="preview-members">
      <small>{{ group.usersCountTotal }} {{ labels.membersInThisGroup }}</small>
      <div>&nbsp;</div>
      <b-button
        class="right"
        variant="primary"
        @click="$emit('editClick', group)"
        v-if="$can('edit', 'group')"
      >
        <i class="mdi mdi-pencil d-inline-block"></i>
        <span class="d-none d-lg-inline-block pl-1"> {{ labels.add }} </span>
      </b-button>
    </section>
    <footer>
      <div>
        {{ labels.subgroups }}
        <b>{{ group.childrenCountDirect || '-' }}</b>
      </div>
      <div>
        {{ labels.managers }}
        <b>{{ group.managersCountDirect || '-' }}</b>
      </div>
      <div>
        {{ labels.updated }}
        <b>{{ updateAt || '-' }}</b>
      </div>
      <div v-if="!$can('access', 'read-only')">
        <ColumnOptions :horizontal="true">
          <div class="column-option">
            <b-button
              variant="link"
              class="btn-outline-primary btn-block"
              @click="removeButtonClicked(group)"
              :disabled="!$can('remove', 'group')"
            >
              {{ labels.remove }}
            </b-button>
          </div>
        </ColumnOptions>
      </div>
    </footer>
  </b-card>
</template>

<script>
import { mapGetters } from 'vuex'
import ColumnOptions from '@/components/CustomPoll/ColumnOptions.vue'
import GroupsInactive from '@/components/Groups/GroupsInactive.vue'

const props = {
  group: {
    type: Object,
    required: true,
  },
}
export default {
  components: { ColumnOptions, GroupsInactive },
  props: props,
  data() {
    return {
      togglePopover: false,
    }
  },
  computed: {
    ...mapGetters({
      resources: 'resources',
    }),

    labels: function() {
      return {
        ...this.resources.page.home.groups.card,
        delete: this.resources.general.buttons.delete,
      }
    },

    updateAt: function() {
      return this.$moment(this.group.updatedAt).format('DD MMM, YYYY')
    },
  },

  methods: {
    removeButtonClicked(group) {
      this.$emit('groupRemoveClick', group)
      this.togglePopover = false
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@/styles/custom/colors';

header {
  cursor: pointer;
}

.inactive-group-header {
  background: map-get($theme-colors, 'gray08') !important;
  footer {
    background: map-get($theme-colors, 'white') !important;
  }
}

.group {
  border-radius: 8px;

  .title {
    color: #32132e;
    display: flex;
    font-size: 20px;
    font-weight: 500;
    justify-content: space-between;

    .btn.go-to-group {
      align-items: center;
      border-width: 2px;
      display: flex;
      font-size: 22px;
      justify-content: center;
      max-height: 32px;
      padding: 0;
      width: 32px;

      &:before {
        align-items: center;
        display: flex;
        font-size: 24px;
        justify-content: center;
        max-height: 25px;
      }
    }
  }

  .preview-members {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    .btn {
      text-transform: none !important;
    }

    small {
      flex-basis: 100%;
      font-size: 14px;
    }
  }

  footer {
    border-top: 1px solid #dfdcdf;
    display: flex;
    justify-content: space-around;
    margin: 20px -20px -20px;
    text-align: center;

    div {
      align-items: center;
      border-right: 1px solid #dfdcdf;
      color: #707070;
      display: flex;
      font-weight: 500;
      font-size: 14px;
      flex-direction: column;
      flex-grow: 1;
      justify-content: center;
      padding: 5px;
      text-transform: uppercase;

      b {
        color: black;

        &.metric-blank {
          color: map-get($theme-colors, 'metric-blank');
        }

        &.metric-low {
          color: map-get($theme-colors, 'metric-low');
        }

        &.metric-medium {
          color: map-get($theme-colors, 'metric-medium');
        }

        &.metric-high {
          color: map-get($theme-colors, 'metric-high');
        }
      }

      &:last-child {
        border: none;
        display: block;
        max-height: 55px;
        position: relative;

        > .btn {
          font-size: large;
          margin: 0 auto;
          max-width: 90%;
        }
      }
    }
    .column-option {
      min-width: 200px;
    }
  }
}
</style>
<style lang="scss">
.tc-popover {
  .btn-link:hover {
    border-color: #32132e;
  }
}
</style>
